import React, { useContext } from 'react'
import { style } from './Footer.style'
import Link from 'next/link'
import { myLink } from '../../shared/styles/myLink'
import { getCategoryJp, getSubcategoryJp } from '../../utils/news'
import { CategoryContext } from './CategoryContext'

type OwnProps = {
  subcategory: 'event' | 'report'
}

const Footer = (props: OwnProps) => {
  const category = useContext(CategoryContext)
  const { subcategory } = props
  const href = `/news/${subcategory}`

  return (
    <footer css={style.links}>
      <Link href={href}>
        <a css={[myLink, style.link(subcategory)]}>一覧を表示</a>
      </Link>
      <Link
        as={href}
        href={{ pathname: href, query: { tag: 'common', subcategory } }}
      >
        <a css={[myLink, style.link(subcategory)]}>
          共通の{getSubcategoryJp(subcategory)}一覧
        </a>
      </Link>
      <Link
        as={href}
        href={{ pathname: href, query: { tag: category, subcategory } }}
      >
        <a css={[myLink, style.link(subcategory)]}>
          {getCategoryJp(category)}の{getSubcategoryJp(subcategory)}一覧
        </a>
      </Link>
    </footer>
  )
}

export default Footer
